import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2.5),
    gap: theme.spacing(0.5),
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
}));
